module.exports = __webpack_public_path__ + "assets/img/guinea.e1b3899e.jpg";